import { DocumentModel, ProgramModel } from '@/lib/models';

export enum ROLE_IDS {
	ADVISORY_IP_MANAGEMENT = 'ADVISORY_IP_MANAGEMENT',
	ADVISOR = 'ADVISOR',
	ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
	GRC_ADVISOR = 'GRC_ADVISOR',
	IMPLEMENTER = 'IMPLEMENTER',
	SUPER_ADMIN = 'SUPER_ADMIN',
	USER = 'USER',
}

export interface AccountModel {
	accountId: string;
	analytics: object;
	clientName: string;
	deliveryDate?: string;
	deliveryDateDescription?: string;
	emailAddress: string;
	hasAdvisoryProfile: boolean;
	location?: string;
	mobileNumber?: string;
	name: string;
	roles: ROLE_IDS[];
	timeZone: {
		id: string;
		description: string;
	};
	title: string;
	userFunctionDescription?: string;
	userFunctionTagIds?: string[];
	userLevelDescription?: string;
	userLevelTagId?: string;
	bookingsUrl?: string;
	availableAiResponseSourceIds?: AI_RESPONSE_SOURCE_IDS[];
	deleted: boolean;
	aiPreferences: {
		aiPreferencesId: string;
		shouldAnimate: boolean;
		showFollowUpQuestions: boolean;
		aiResponseSourceIds: AI_RESPONSE_SOURCE_IDS[];
		aiResponseSourceGroupingId: AI_RESPONSE_SOURCE_GROUPING_IDS;
	} | null;
	programs: ProgramModel[];
}

export enum AI_RESPONSE_SOURCE_IDS {
	HACKETT_IP = 'HACKETT_IP',
	INQUIRIES = 'INQUIRIES',
	WEB = 'WEB',
}

export enum AI_RESPONSE_SOURCE_GROUPING_IDS {
	SEPARATED = 'SEPARATED',
	COMBINED = 'COMBINED',
}

export interface UnmatchedAccountModel {
	company: string;
	email: string;
	phone: string;
	title: string;
	userName: string;
}

export interface AccountOptionModel {
	tagId: string;
	name: string;
}

export interface BannerMessage {
	bannerMessageId: string;
	title: string;
	linkDescription: string;
	linkUrl: string;
}

export interface AccountBookmarkModel {
	bookmarkId: string;
	bookmarkType: BOOKMARK_TYPE.DOCUMENT;
	bookmarkContent: DocumentModel;
}

export enum BOOKMARK_TYPE {
	DOCUMENT = 'DOCUMENT',
}

export interface AccountTopicPreference {
	topicId: string;
	topicName: string;
	enabled: boolean;
}

export enum ALERT_FREQUENCY {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
}
